module.exports = __webpack_public_path__ + "img/gmail.a8077789.png";